import Entity from "./entity";

/**
 * Object representation for a Product document from the database.
 */
class NotifyToken extends Entity {
  constructor({ id } = {}) {
    super({ id: id });
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    let map = {
      id: this.id
    };

    return map;
  }

  /**
   * @param {*} snapData NotifyToken document data as a plain JS object
   * snapshot represented by this `NotifyToken`.
   * @returns {NotifyToken} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    return new NotifyToken(snapData);
  }

  get _collectionName() {
    return `notifyTokens`;
  }

  get _entityName() {
    return "notifyToken";
  }
}

export default NotifyToken;
